module.exports = __webpack_public_path__ + "img/legal_now.d85f40af.svg";